let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8lTz4")).then(() => parcelRequire('eKrR2'));